import { Box, useMediaQuery } from "@mui/material";
import { observer } from "mobx-react-lite";
import FigmaFaqSection from "../../components/Home/Figma/FigmaFaqSection/FigmaFaqSection";
import FigmaHeaderSection from "../../components/Home/Figma/FigmaHeaderSection/FigmaHeaderSection";
import FigmaInstallSection from "../../components/Home/Figma/FigmaInstallSection/FigmaInstallSection";
import styles from "./FigmaTab.module.scss";

const FigmaTab = () => {
	const isBigScreen = useMediaQuery("(min-width:2460px)");
	return (
		<Box className={styles.container}>
			<Box className={styles.figmaInstructionsContainer}>
				<FigmaHeaderSection />
				{!isBigScreen && <FigmaInstallSection />}
			</Box>
			<FigmaFaqSection />
		</Box>
	);
};

export default observer(FigmaTab);
